import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import { ReactComponent as TwitterLogo } from "../images/twitter.svg"
import { ReactComponent as FacebookLogo } from "../images/facebook.svg"

const Footer = () => (
  <footer>
    <div className="sitemap">
      <div>
        <div className="sitemap-inner">
          <div>
            <h3>
              <Link to="/programming/">プログラミング教室</Link>
            </h3>
          </div>
          <div>
            <h3>
              <Link to="/workshop/">電子工作教室</Link>
            </h3>
          </div>
          <div>
            <h3>
              <Link to="/exhibition/">学生製作物展示</Link>
            </h3>
          </div>
          <div>
            <h3>
              <a href="http://nanotechnet.t.u-tokyo.ac.jp/kairo/index.html">研究室紹介</a>
            </h3>
          </div>
        </div>
        <div className="social-logos">
          <a
            href="https://twitter.com/eeic_studentadv"
            rel="nofollow noopener noreferrer"
            target="_blank"
            className="social-logo"
          >
            <TwitterLogo width="40" height="40" className="twitter-logo" />
          </a>
          <a
            href="https://www.facebook.com/eeic.studentadv"
            rel="nofollow noopener noreferrer"
            target="_blank"
            className="social-logo"
          >
            <FacebookLogo width="40" height="40" className="facebook-logo" />
          </a>
        </div>
      </div>
    </div>
    <div className="copy">
      Copyright © EEIC 五月祭展示「近未来体験2020」 All rights reserved.
    </div>
  </footer>
)

Footer.propTypes = {
  siteTitle: PropTypes.string,
}

Footer.defaultProps = {
  siteTitle: ``,
}

export default Footer
